import { Btn, H5, Image, LI, P, UL } from "../../../../AbstractElements";
import { CenteredError, Close } from "../../../../Constants/Constants";
import { CenterdModalBodyProps } from "../../../../Types/UiKitsType";
import { dynamicImage } from "../../../../Utils";
import CommonModal from "../Common/CommonModal";

const CenterdModalBody: React.FC<CenterdModalBodyProps> = ({ modal, toggle }) => {
  const data = {isOpen: modal,center: true,toggler: toggle};
  return (
    <CommonModal modalData={data}>
      <div className="modal-toggle-wrapper">
        <UL className="modal-img simple-list">
          <LI className="text-center"><Image src={dynamicImage(`gif/danger.gif`)} alt="error" /></LI>
        </UL>
        <H5 className="text-center pb-2">{CenteredError}</H5>
        <P className="text-center">{"Attackers on malicious activity may trick you into doing something dangrous like installing software or revealing your personal informations."}</P>
        <Btn color="secondary" className="d-flex m-auto" type="button" onClick={toggle}>{Close}</Btn>
      </div>
    </CommonModal>
  );
};
export default CenterdModalBody;
